<template>
	<page>
		<module enable-flex>
			<m-search ref="search" :default-data="defaultSearchData" @search="searchHandle">
				<m-search-item label="关键字">
					<c-input name="keyword" maxlength="100"></c-input>
				</m-search-item>
                <m-search-item label="创建时间" colspan="2">
                    <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                </m-search-item>
                <m-search-item label="是否已读">
                    <c-checkbox-group name="read_flags" :options="readFlagStateDic"></c-checkbox-group>
                </m-search-item>
			</m-search>

			<m-operate>
				<template>
					<c-button prepend-icon="tf-check" @click="markAllRead">全部已读</c-button>
				</template>
			</m-operate>

			<c-table ref="list" height="grow" :paging="true">
				<c-table-column
					label="标题"
					name="title"
					width="80"
				></c-table-column>

				<c-table-column
					label="内容"
					name="content"
                    width="300"
				></c-table-column>

				<c-table-column
					label="是否已读"
					name="rule_type"
					width="60"
				>
					<template #default="{data}">
                        <c-state  dict="readFlagStateDic" tag :value="data.read_flag"></c-state>
					</template>
				</c-table-column>

				<c-table-column
					label="创建时间"
					name="create_date"
					width="140"
				></c-table-column>

				<c-table-column
					type="button"
					label="操作"
					width="60"
					button-limit="3"
				>
					<template #default="{data}">
                        <c-table-button icon="tf-view" @click="showMessageDetail(data)">详情</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
    import { mapState } from 'vuex';


	export default {
		components: {
		},

		data() {
			return {
				defaultSearchData: {
					read_flags: [1]
				},
				lastSearchData: {}
			}
		},

        computed:{
            ...mapState(['readFlagStateDic'])
		},

		mounted() {
			this.searchHandle({ read_flags: [1] });
		},

		methods: {
			searchHandle(data){
				if (!data){
					data = {};
				}
				this.lastSearchData = data;
				this.$refs.list.load({
					url: '/message/list',
					data,
					success: () => {
					}
				});
			},

			markAllRead() {
				this.request({
					url: '/message/readAll',
					success: () => {
						this.searchHandle(this.lastSearchData);
					}
				});
			},

			showMessageDetail(data) {
                //将站内信标记为已读
                if (data.read_flag == 1){
                    this.request({
                        url: '/message/read',
                        data: {
                            id: data.id
                        },
                        success: (data, message) => {
                            //刷新列表
                            this.$refs.list.update();
                        }
                    });
                }

                let jsonObj = JSON.parse(data.params);
                if (jsonObj && jsonObj.id && data.redirect_url == '/aftersales/work/detail'){       //工单详情
                    this.globalDialog('afterSaleOrderDetail', {props: {id: jsonObj.id}})
                }else if (jsonObj && jsonObj.id && data.redirect_url == '/assets/receive/detail'){  //物资领用
                    this.globalDialog('assetReceiveApplyDetail', {props: {id: jsonObj.id}})
                }else if (jsonObj && jsonObj.id && data.redirect_url == '/aftersales/outsource/detail'){  //外协招工
                    this.globalDialog('outsourceRrecruitDetail', {props: {id: jsonObj.id}})
                }else if (jsonObj && jsonObj.id && data.redirect_url == '/assets/return/detail'){  //物资归还
                    this.globalDialog('assetReturnDetail', {props: {id: jsonObj.id}})
                }else if (jsonObj && jsonObj.id && data.redirect_url == '/affairs/leave/detail'){  //请假
                    this.globalDialog('leaveApplicationDetail', {props: {id: jsonObj.id}})
                }else if (jsonObj && jsonObj.id && data.redirect_url == '/finance/reimb/detail'){  //请假
                    this.globalDialog('expenseReimbursementDetail', {props: {id: jsonObj.id}})
                }else if(jsonObj && jsonObj.id && data.redirect_url == '/affairs/overtime/detail') {
                    this.globalDialog('overtimeApplicationDetail', {props: {id: jsonObj.id}})
                }

			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
